<template>
<div class="chapter">
<div class="inner_page">
<p class="normal-d">Dedicated, with sincere respect, to the men and women of White Sands, birthplace of America’s missile and space activity.</p>
<p class="normal-d1">Well done. Keep on.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?0d06f2b3